import axios from "axios";

const dapiInstance = axios.create({
  baseURL: `${process.env.VUE_APP_DAPIURL}`,
  headers: {
    locale: "es-ES",
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export const getCountries = async () => {
  return dapiInstance("/masterdata/countries");
};

export default dapiInstance;
